<template>
  <div class="index main">
    <div
      v-if="settings"
      class="page-header-wrapper"
      :style="headerStyle"
    >
      <div class="page-header translucent-wrapper">
        <span class="button-wrapper" @click="handleLoadServicePhoto"><a class="button is-info">+</a>Загрузить фото</span>
        <b-field>
            <b-input
              v-model="settingsObject.mainPageTitle"
              placeholder="Заголовок"
              required
              @change="handleUpdate"
            ></b-input>
        </b-field>
        <b-field>
          <b-input placeholder="Текст" type="textarea" required v-model="settingsObject.mainPageDescription" @change="handleUpdate"></b-input>
        </b-field>
        <b-field>
          <b-input placeholder="Ссылка на видео" required v-model="settingsObject.mainPageVideo" @change="handleUpdate"></b-input>
        </b-field>
      </div>
      <input
        type="file"
        id='photo'
        @change='loadPhoto'
        hidden
        ref="loadPhotoButton"
      />
    </div>
    <div class="floating-rows drag box mt-10">
      <div class="drag-info">
        <div class="drag-info-content">
          <img src="/static/img/icons/move.svg" class="drag-icon" />
          <p>
          Чтобы поменять местами услуги на главной удерживайте и перетаскивайте их <br>
          Порядок отображения на главной странице влияет на порядок отображения пунктов услуг в меню
          </p>
        </div>
      </div>

      <h2>
        Услуги первого типа
      </h2>
      <draggable
        group="order"
        class="drag-area"
        :value="firstTypeServices"
        @change="commonServicesChange($event, 0)"
      >
        <ServiceItem
          class="row"
          v-for="service in firstTypeServices"
          :key="service.id"
          :service="service"
          @input="commonServicesUpdated"
          @remove="commonServicesRemove"
        />
        <div class="centered">
          <span
            class="button-wrapper centered"
            @click="add(0)"
          >
            <a class="button is-info">+</a>
            Добавить
          </span>
        </div>
      </draggable>

      <h2>
        Услуга второго типа
      </h2>
      <p>
        (может содержать в себе только 1 элемент)
      </p>
      <draggable
        group="order"
        class="drag-area"
        :value="secondTypeServices"
        @change="commonServicesChange($event, 1)"
      >
        <ServiceItem
          class="row"
          v-for="service in secondTypeServices"
          :key="service.id"
          :service="service"
          @input="commonServicesUpdated"
          @remove="commonServicesRemove"
        />
        <div class="centered">
          <span
            class="button-wrapper centered"
            @click="add(1)"
          >
            <a class="button is-info">+</a>
            Добавить
          </span>
        </div>
      </draggable>
      <h2>
        Услуги третьего типа
      </h2>
      <draggable
        group="order"
        class="drag-area"
        :value="thirdTypeServices"
        @change="commonServicesChange($event, 2)"
      >
        <ServiceItem
          class="row"
          v-for="service in thirdTypeServices"
          :key="service.id"
          :service="service"
          @input="commonServicesUpdated"
          @remove="commonServicesRemove"
        />
        <div class="centered">
          <span
            class="button-wrapper centered"
            @click="add(2)"
          >
            <a class="button is-info">+</a>
            Добавить
          </span>
        </div>
      </draggable>

    </div>
    <div class="save-content-button centered">
      <button
        class="button save-content"
        :disabled="disabled"
        @click="handleSaveMainPage()"
      >
        {{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}
      </button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import draggable from 'vuedraggable'
  import deepcopy from 'deepcopy'
  import ServiceItem from 'components/Main/ServiceItem'

  export default {
    name: 'Main',
    data () {
      return {
        updateTimer: null,
        disabled: false
      }
    },
    computed: {
      ...mapState([
        'services',
        'commonServices',
        'settings'
      ]),
      settingsObject () {
        return deepcopy(this.settings)
      },
      headerStyle () {
        return this.settingsObject.mainPagePhoto
        ? {background: !this.settingsObject.mainPagePhoto.base64photo
          ? `url(/upload/photos/${this.settingsObject.mainPagePhoto})`
          : `url(${this.settingsObject.mainPagePhoto.base64photo})`}
        : {background: ''}
      },
      firstTypeServices () {
        return deepcopy(this.commonServices)
          .filter(service => service.groupNumber === 0)
      },
      secondTypeServices () {
        return deepcopy(this.commonServices)
          .filter(service => service.groupNumber === 1)
      },
      thirdTypeServices () {
        return deepcopy(this.commonServices)
          .filter(service => service.groupNumber === 2)
      }
    },
    methods: {
      ...mapActions([
        'getSortedServices',
        'saveMainPage',
        'getSettings',
        'updateSettings',
        'loadMainPagePhoto',
        'updateServiceOrder',
        'getCommonServices',
        'addCommonServices',
        'rmCommonServices'
      ]),
      handleSaveMainPage () {
        this.disabled = true
        this.saveMainPage()
        .then(() => {
          this.disabled = false
          this.$toast.open({ message: 'Сохранено' })
        })
      },
      handleUpdate () {
        clearTimeout(this.updateTimer)
        this.updateTimer = setTimeout(() => {
          this.updateSettings(this.settingsObject)
        }, 100)
      },
      handleLoadServicePhoto () {
        this.$refs.loadPhotoButton.click()
      },
      loadPhoto (e) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('avatar', file)
        reader.onload = (e) => {
          this.settingsObject.mainPagePhoto = {
            base64photo: e.target.result,
            data: formData,
            id: this.settingsObject.id
          }
          this.handleUpdate()
        }
      },
      filteredServices (serviceTypeId) {
        return this
          .commonServices
          .filter(el => el.common_services_type_id === serviceTypeId)
      },
      add (groupNumber) {
        const newService = {
          groupNumber,
          description: '',
          title: '',
          url: '',
          photo: '',
          items: new Array(4),
          enable: false
        }

        this.addCommonServices(newService)
      },
      commonServicesChange (event, groupNumber) {
        let values = deepcopy(this.commonServices)

        if (event.added) {
          const foundINdex = values.findIndex(el => el.id === event.added.element.id)
          values[foundINdex].groupNumber = groupNumber
        }

        if (event.moved) {
          if (event.moved.newIndex > event.moved.oldIndex) {
            values[event.moved.oldIndex].order++
            values[event.moved.newIndex].order--
          } else {
            values[event.moved.oldIndex].order--
            values[event.moved.newIndex].order++
          }

          values[event.moved.newIndex].groupNumber = groupNumber
        }

        values = values.sort((a, b) => a.order - b.order)

        this.$store.commit('SET_COMMON_SERVICES', values)
      },
      commonServicesUpdated (service) {
        let values = deepcopy(this.commonServices)
        const foundIndex = values.findIndex(
          el => el.id === service.id
        )

        values[foundIndex] = service

        this.$store.commit('SET_COMMON_SERVICES', values)
      },
      commonServicesRemove (service) {
        this.rmCommonServices(service.id)
      }
    },
    components: {
      draggable, ServiceItem
    },
    created () {
      this.getCommonServices()
      this.getSortedServices()
      // this.getSettings()
    }
  }
</script>

<style>
.main .page-header-wrapper {
  height: calc(100vh - 104px);
}
.page-header-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-header {
  width: 100%;
  max-width: 700px;
}
.page-header .button-wrapper {
  justify-content: center;
}
.button-wrapper {
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  margin: 15px 0;
}
.button-wrapper .button {
  border-radius: 50%;
  margin: 0 10px 0 0;
}
.drag-info {
  width: calc(100% - 10px);
  margin: 0 auto;
  background: #3273dc;
  padding: 10px;
  border-radius: 15px;
  color: #fff;
}
.drag-icon {
  margin: 0 10px 0 0;
  width: 25px;
}
.drag-area {
  min-height: 100px;
}
.drag-info-content {
  display: flex;
  align-items: center;
  max-width: 700px;
  font-size: 14px;
  margin: 0 auto;
}
.index .row-content-wrapper {
  max-width: 1000px;
  margin: 0 auto;
}
.row-content-wrapper > div {
  width: 50%;
  max-width: 600px;
  float: left;
}
.index .row {
  background: #eeeeee;
  margin: 15px auto;
  padding: 30px 5px;
}
.index h2 {
  font-weight: bold;
  margin: 15px 0 5px 0;
  font-size: 22px;
}
.row-description p {
  font-style: italic;
  margin: 0 0 10px 0;
}
.row-description ul {
  padding: 0px 20px;
}
.row-description ul li {
  list-style: disc;
}
.photo {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.photo span {
  cursor: pointer;
  color: #1464f6;
  margin: 15px 0;
}
.switch span {
  color: #1464f6;
}
.row img{
  width: 200px;
}
.commodity-market {
  background: #eeeeee;
  text-align: center;
  padding: 20px;
}
.commodity-market p {
  max-width: 435px;
  margin: 0 auto
}
.commodity-market img {
  width: 170px;
}
.commodity-market .photos {
  display: flex;
  justify-content: center;
}
.commodity-market .photo {
  padding: 10px 40px;
}
.nav:empty {
  display: none
}
</style>



// WEBPACK FOOTER //
// Index.vue?958e5c8e